export default "__VITE_ASSET__e7518361__"